import { render, staticRenderFns } from "./DownloadFileButtons.vue?vue&type=template&id=497348f0&scoped=true"
import script from "./DownloadFileButtons.vue?vue&type=script&lang=js"
export * from "./DownloadFileButtons.vue?vue&type=script&lang=js"
import style0 from "./DownloadFileButtons.vue?vue&type=style&index=0&id=497348f0&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "497348f0",
  null
  
)

export default component.exports